import { useTranslation } from 'react-i18next'

import ErrorCrossIcon from '@/assets/icons/error-cross.svg'
export const PhonePopupError = () => {
  const { t } = useTranslation()

  return (
    <div className="animate-fade-in flex flex-col items-center gap-4 px-4 py-8">
      <img src={ErrorCrossIcon} alt="error" className="aspect-square h-15" />
      <p className="mt-4 text-center">{t('sms_reminder.error')}</p>
    </div>
  )
}
